import Form from 'app/components/Form';

import {
  productTypeOptions
} from 'app/utils/options';

const JobConfigTemplateForm = props => {
  const {
    jobConfigTemplate,
    onClose,
    onSubmit,
    action
  } = props;

  let header = null;
  if (action === 'update') {
    header = 'Edit Fields';
  }

  // the job delivery method is obsolete now.
  // hard coding to 2 (Web App) until it's removed
  //const deliveryMethodOptions = [
  //  { label: 'In App', value: 0 },
  //  { label: 'Hashtag', value: 1 },
  //  { label: 'Web App', value: 2 },
  //  { label: 'PWA', value: 3 },
  //  { label: 'Web Cart to PWA', value: 4 },
  //];

  // the job selling method is mostly obsolete,
  // except for the None selling method,
  // which might be used to toggle the premium flag.
  // hard coding to 2 (In App Purchase) for now
  //const sellingMethodOptions = [
  //  { label: 'None', value: 0 },
  //  { label: 'Web Cart', value: 1 },
  //  { label: 'In App Purchase', value: 2 },
  //  { label: 'In App Proofing', value: 3 },
  //  { label: 'In App Backgrounds', value: 4 },
  //  { label: 'Upgrdio', value: 5 }
  //];

  let fields = [
    { name: 'name', label: 'Product name', type: 'text', value: jobConfigTemplate?.name },
    { name: 'product_type', label: 'Product Type', type: 'select', value: jobConfigTemplate?.product_type, valueType: 'integer', options: productTypeOptions, hideNoneOption: true },
    { name: 'description', label: 'Product description', type: 'textarea', value: jobConfigTemplate?.description },
    { name: 'instructions', label: 'How to use this product', type: 'textarea', value: jobConfigTemplate?.instructions },
    { name: 'visible', label: 'Visible?', type: 'checkbox', value: jobConfigTemplate?.visible },
    { name: 'delivery_method', type: 'hidden', value: jobConfigTemplate?.delivery_method || 2, valueType: 'integer' },
    { name: 'selling_method', type: 'hidden', value: jobConfigTemplate?.selling_method || 2, valueType: 'integer' },
    { name: 'enable_hashtag', type: 'hidden', value: jobConfigTemplate?.enable_hashtag || false },
    { name: 'shared_story', type: 'boolean', value: jobConfigTemplate?.shared_story || false },
    { name: 'preserve_premium', label: 'Preserve premium flags?', type: 'checkbox', value: jobConfigTemplate?.preserve_premium },
  ]

  return (
    <Form {...{
      header,
      fields,
      action,
      onClose,
      onSubmit
    }} />
  );
}

export default JobConfigTemplateForm;

